export const MODAL_IMPORTANCE_LEVEL = {
  REGULAR: 'regular',
  IMPORTANT: 'important',
} as const;
